import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionTitle } from '@containers/Admin/containers/UserPage/user-page-wrapper/components/UserPersonalProgram/components/ListItemSection/styles';
import { SkillsItem } from '@containers/Admin/containers/UserPage/user-page-wrapper/components/UserPersonalProgram/components/SkillsItem';
import { SkillPart, SkillPartType } from '@app-types/skill.types';

type SkillPartSectionProps = {
  types: SkillPartType[];
  skillParts: SkillPart[];
  currentEntityId?: string;
  flaggedEntityId?: string;
  availableEntityIds?: Set<string>;
  allAvailable?: boolean;
  extraSpacings?: boolean;
};

export const SkillPartSection = ({ skillParts, currentEntityId, flaggedEntityId, availableEntityIds, allAvailable, types, extraSpacings }: SkillPartSectionProps) => {
  const { t } = useTranslation();

  const filteredSkillParts = useMemo(() => skillParts.filter((part) => types.includes(part.type)), [skillParts, types]);

  if (filteredSkillParts.length === 0) {
    return null;
  }

  return (
    <>
      <SectionTitle extraSpacings={extraSpacings}>{types.map((type) => t(`Common.UI.${type.toLowerCase()}`)).join(' & ')}</SectionTitle>
      {filteredSkillParts.map((skillPart) => (
        <SkillsItem
          key={skillPart.id}
          resource={skillPart}
          type={skillPart.type}
          isFirstElement={false}
          isCurrentLevel={skillPart.id === currentEntityId}
          isFlagged={skillPart.id === flaggedEntityId}
          isAvailable={allAvailable || availableEntityIds?.has(skillPart.id)}
        />
      ))}
    </>
  );
};
